

























import Vue from 'vue'
import { IPaymentMethod } from '@/models'

export default Vue.extend({
    name: 'PaymentMethodListItem',

    props: {
        method: {
            type: Object as () => IPaymentMethod,
            required: true,
        },
        selectedMethod: Object as () => IPaymentMethod,
    },

    computed: {
        isSelected(): boolean {
            return this.selectedMethod?.methodID === this.method.methodID
        },
    },

    methods: {
        selectMethod() {
            this.$emit('select', this.method)
        },
    },
})
